<form [formGroup]="form" *ngIf="config && form">
  <div class="form-group">
    <label class="bmd-label-floating" for="vendorId">
      Vendor ID
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="vendorId"
      name="vendorId"
    />
  </div>

  <div class="form-group">
    <label class="bmd-label-floating" for="user">
      User
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="user"
      name="user"
    />
  </div>

  <div class="form-group">
    <label class="bmd-label-floating" for="password">
      Password
    </label>
    <input
      type="password"
      class="form-control"
      formControlName="password"
      name="password"
    />
  </div>
</form>
